<template>
    <v-btn v-bind="{ ...$attrs, loading }" @click="update">
        <slot />
    </v-btn>
</template>

<script>
import api from "@/api";
import { initManufacturingMaterial } from "@/assets/variables";

export default {
    props: {
        loading: { type: Boolean, default: false },
        material: { type: Object, default: initManufacturingMaterial },
        link: { type: Object, default: () => ({}) },
    },
    methods: {
        async update() {
            if (this.loading) return;
            else this.$emit("setLoading", true);

            try {
                const { _id: _material } = this.material;
                const { _id: _link } = this.link;

                await api.console.manufacturing.materials.links.updateMaterial.post({ _material, _link });
                this.$emit("setLoading", false);
                this.$emit("init");
            } finally {
                if (this.loading) this.$emit("setLoading", false);
            }
        },
    },
};
</script>

<style></style>
